import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { breakpoint } from '@zocdoc/components/src/grid';
import { Button } from '@zocdoc/components/src/button';
import { grey10 } from '@zocdoc/branding/colors';

import ComputerDesk from './ComputerDesk.svg';
import { Container, Headline, Paragraph } from '../Panel';

function CareersPanel({ trackCheckOurCareersPage }) {
    return (
        <CareersPanelContainer>
            <Headline>
                <FormattedMessage
                    defaultMessage="Psst. Want a job?"
                    id="Home.Careers.Header"
                />
            </Headline>
            <CareersPanelText>
                <FormattedMessage
                    defaultMessage="Zocdoc has won workplace awards from Crain's NYC, Modern Healthcare, and Fortune."
                    id="Home.Careers.WorkplaceAwards"
                />
            </CareersPanelText>
            <div>
                <CheckCareersPageLink
                    beforeClick={trackCheckOurCareersPage}
                    data-test="careers-panel-button"
                    href="/about/careers/"
                >
                    Check our careers page
                </CheckCareersPageLink>
            </div>
        </CareersPanelContainer>
    );
}

CareersPanel.propTypes = {
    trackCheckOurCareersPage: PropTypes.func,
};

CareersPanel.defaultProps = {
    trackCheckOurCareersPage: noop,
};

const CareersPanelContainer = styled(Container)`
    flex-direction: column;

    background-color: ${grey10};
    background-size: auto 75%;
    background-repeat: no-repeat;

    ${breakpoint.small} {
        align-items: center;
        padding-top: 120px;
        padding-bottom: 200px;

        background-position: 450px 100%;
        background-image: url(${ComputerDesk});
    }
    ${breakpoint.medium} {
        align-items: flex-start;
        padding-top: 184px;
        padding-right: 50%;
        padding-bottom: 0;

        background-position: 500px 100%;
    }
    ${breakpoint.large} {
        padding-right: 55%;

        background-position: 655px 100%;
    }
`;

const CareersPanelText = styled(Paragraph)`
    max-width: 500px;
`;

const CheckCareersPageLink = styled(Button)`
    margin-top: 32px;
`;

export default CareersPanel;
